// src/components/HomeSlider.js
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import './HomeSlider.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Import images
import img1 from '../assets/img1.webp';
import img2 from '../assets/img2.jpg';
import img3 from '../assets/img3.webp';
import img4 from '../assets/img4.jpg';
import img5 from '../assets/img5.webp';

const HomeSlider = () => {
  const [loadedImages, setLoadedImages] = useState({});
  const [activeSlide, setActiveSlide] = useState(0);
  
  const sliderImages = [img1, img2, img3, img4, img5];
  
  // Different subheadings for each slide
  const subHeadings = [
    "Maharashtra's First & Biggest Luggage Mall",
    "25+ Premium Brands Under One Roof",
    "Your Ultimate Travel Solutions Hub",
    "Family-Friendly Shopping Experience",
    "Expert Guidance & Lifetime Support"
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    lazyLoad: 'progressive',
    beforeChange: (current, next) => setActiveSlide(next),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  };

  // Image preloading
  useEffect(() => {
    sliderImages.forEach((img, index) => {
      const image = new Image();
      image.src = img;
      image.onload = () => {
        setLoadedImages(prev => ({ ...prev, [index]: true }));
      };
    });
  }, []);

  return (
    <div className="home-slider">
      <Slider {...settings}>
        {sliderImages.map((img, index) => (
          <div key={index}>
            <div className="slide">
              <div 
                className={`slide-image ${loadedImages[index] ? 'loaded' : 'blur'}`}
                style={{ backgroundImage: `url(${img})` }}
              />
              <div className="slide-overlay">
                <div className="slide-content">
                  <h1>Welcome to Kothari Luggage Mall</h1>
                  <h2 className={`subheading ${activeSlide === index ? 'active' : ''}`}>
                    {subHeadings[index]}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeSlider;